import { Space, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import productosAlCostoPdf from "../../../../Pdf/productosAlCostoPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalProductosAlCostoPdf extends Component {
  _isMounted = false;
  state = { loading: false, pdf: null };

  componentDidMount() { this._isMounted = true; }
  componentWillUnmount() { this._isMounted = false; }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarDatosPdf();
    }
  }

  async consultarDatosPdf() {
    this.setState({ loading: true });
    axios.post("productosAlCosto/datosPdf", 
      { ordenId: this.props.ordenId, empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    ).then((res) => {
      if (!this._isMounted) return;
      console.log(res.data)
      if (res.data.success === 2) {
        const generador = productosAlCostoPdf(res.data);
        const pdf = pdfMake.createPdf(generador);
        this.setState({ loading: false, pdf }, () => {
          pdf.open({}, window.frames["ProductosAlCostoPdfIframe"]);
        });
      } else {
        message.error("No se encontraron datos");
        this.setState({ loading: false });
      }
    }).catch(() => {
      if (this._isMounted) this.setState({ loading: false });
    });
  }

  descargarPdf = () => {
    if (this.state.pdf) {
      this.state.pdf.download(`Orden_Productos_Al_Costo_${this.props.ordenNumero || "Doc"}.pdf`);
    }
  };

  render() {
    return (
      <ModalItem
        title="Vista Previa Productos al Costo"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.props.onCancel}
        width={800}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
          <Space>
            <ButtonItem icon={<DownloadOutlined />} type="primary" onClick={this.descargarPdf}>
              Descargar PDF
            </ButtonItem>
            <ButtonItem danger onClick={this.props.onCancel}>Cerrar</ButtonItem>
          </Space>
        </div>
        <iframe
          title="Productos Al Costo PDF"
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="ProductosAlCostoPdfIframe"
          name="ProductosAlCostoPdfIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalProductosAlCostoPdf);